import OpenSubmissions from './OpenSubmissions';
import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import {
    initialOpenSubmissionsConfiguration,
    OpenSubmissionsConfiguration,
} from './store/configuration/OpenSubmissionsConfiguration';
import { OrderColumns } from 'communication/types/order/Order';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { openSubmissionsDescription } from './description/openSubmissionsDescription';
import { openSubmissionsWidgetStreamConfig } from 'widgets/openSubmissions/store/stream/stream-config';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';

export const openSubmissionsWidgetStrategy: WidgetStrategyWithConfig<OpenSubmissionsConfiguration> &
    WidgetStrategyWithStreams = {
    title: 'Open Submissions',
    supportedHosts: ['layout'],
    reactComponentType: OpenSubmissions,
    initialConfigState: initialOpenSubmissionsConfiguration,
    getRequiredOrderColumns: getOpenSubmissionRequiredOrderColumns,
    categories: [WidgetCategory.SINGLE_STOCK],
    description: openSubmissionsDescription,
    streamConfigs: [openSubmissionsWidgetStreamConfig],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
};

export function getOpenSubmissionRequiredOrderColumns(): OrderColumns {
    return ['qty', 'fillQty', 'avgPx', 'curcy'];
}
